/** simple types */
import ConcatCell from './templates/ConcatCell.vue';
/** specific array values */
import ContractActionArrayCell from './templates/ContractActionArrayCell.vue';
import ContractActionByDateCell from './templates/ContractActionByDateCell.vue';
import ContractAreasArrayCell from './templates/ContractAreasArrayCell.vue';
import ContractClausesArrayCell from './templates/ContractClausesArrayCell.vue';
import ContractContactPersonsArrayCell from './templates/ContractContactPersonsArrayCell.vue';
import ContractPartnersArrayCell from './templates/ContractPartnersArrayCell.vue';
import ContractPaymentsArrayCell from './templates/ContractPaymentsArrayCell.vue';
import CostInvoiceItemStatusBadgeCell from './templates/CostInvoiceItemStatusBadgeCell.vue';
import CustomerGroupArrayCell from './templates/CustomerGroupArrayCell.vue';
import CustomerGroupCell from './templates/CustomerGroupCell.vue';
import CustomersArrayCell from './templates/CustomersArrayCell.vue';
import DateArrayCell from './templates/DateArrayCell.vue';
import DateArrayCellCollapsible from './templates/DateArrayCellCollapsible.vue';
import DateCell from './templates/DateCell.vue';
/** arrays */
import EnumArrayCell from './templates/EnumArrayCell.vue';
import InvoiceNameOrIdCell from './templates/InvoiceNameOrIdCell.vue';
import InvoiceSource from './templates/InvoiceSource.vue';
import Megabyte from './templates/Megabyte.vue';
import MimetypeCell from './templates/MimetypeCell.vue';
import ObjectArrayCell from './templates/ObjectArrayCell.vue';
import ObjectCell from './templates/ObjectCell.vue';
import PartnerGroupCell from './templates/PartnerGroupCell.vue';
import PartnersArrayCell from './templates/PartnersArrayCell.vue';
import PointOfSalesCell from './templates/PointOfSalesCell.vue';
/** specific simple values */
import ProcessNameBadgeCell from './templates/ProcessNameBadgeCell.vue';
import RelatedTicketCell from './templates/RelatedTicketCell.vue';
import SfmChildPositionArrayCell from './templates/SfmChildPositionArrayCell.vue';
import SignatureArrayCell from './templates/SignatureArrayCell.vue';
import SimpleConnectEnumArrayCell from './templates/SimpleConnectEnumArrayCell.vue';
import StringArrayCell from './templates/StringArrayCell.vue';
import StringCell from './templates/StringCell.vue';
import TicketStatusBadgeCell from './templates/TicketStatusBadgeCell.vue';

export const TemplateComponentCache = {
  strings: StringCell,
  concatString: ConcatCell,
  attachments: StringCell,
  enumArray: EnumArrayCell,
  object: ObjectCell,
  objectArray: ObjectArrayCell,
  dateArray: DateArrayCell,
  dateArrayCollapsible: DateArrayCellCollapsible,
  dateCell: DateCell,
  contractActionArray: ContractActionArrayCell,
  contractActionByDate: ContractActionByDateCell,
  contractPartnersArray: ContractPartnersArrayCell,
  contractContactPersonsArray: ContractContactPersonsArrayCell,
  contractAreasArray: ContractAreasArrayCell,
  contractClausesArray: ContractClausesArrayCell,
  contractPaymentsArray: ContractPaymentsArrayCell,
  signatureArray: SignatureArrayCell,
  ticketStatusBadge: TicketStatusBadgeCell,
  processNameBadge: ProcessNameBadgeCell,
  costInvoiceItemStatusBadge: CostInvoiceItemStatusBadgeCell,
  pos: PointOfSalesCell,
  customers: CustomersArrayCell,
  partners: PartnersArrayCell,
  customerGroupArray: CustomerGroupArrayCell,
  customerGroup: CustomerGroupCell,
  partnerGroup: PartnerGroupCell,
  mimetype: MimetypeCell,
  megabyte: Megabyte,
  invoiceSource: InvoiceSource,
  invoiceNameOrIdCell: InvoiceNameOrIdCell,
  simpleConnectEnumArray: SimpleConnectEnumArrayCell,
  sfmChildPositionArray: SfmChildPositionArrayCell,
  stringArray: StringArrayCell,
  relatedTicket: RelatedTicketCell,
  //   classificationStatus: ClassificationStatusCell,
  //   subject: SubjectCell,
  default: StringCell,
};

export type AssignableTemplateNames = keyof typeof TemplateComponentCache;
